import {
    getMeter,
    listMeters
} from './queries';
import {
    activateMeter,
    createMeter,
    deleteMeter,
    updateMeter,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {Meter} from "../types.ts";
import { billingApiClient } from "../../billing-api-integration";
import {ListRecordsQuery} from "../../../types";


export type ListMeters = {
    listMeters: { items: Meter[], nextToken: string }
}

export type GetMeter = {
    getMeter: Meter
}

export type CreateMeter = {
    createMeter: Meter
}

export type UpdateMeter = {
    updateMeter: Meter
}

export type DeleteMeter = {
    deleteMeter: string
}

export type ActivateMeter = {
    activateMeter: Meter
}


const client = billingApiClient;

export const fetchRecords = async (query: ListRecordsQuery) => {
    const response = await client.graphql<GraphQLQuery<ListMeters>>({
                                                                        query: listMeters,
                                                                        variables: {
                                                                            ...query
                                                                        },
                                                                    });
    return {
        items: response.data?.listMeters.items,
        nextToken: response.data?.listMeters.nextToken
    }
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetMeter>>({
                                                                      query: getMeter,
                                                                      variables: {id: id},
                                                                  });
    return response.data?.getMeter;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateMeter>>({
                                                                         query: createMeter,
                                                                         variables: {input: payload},
                                                                     });
    console.debug('in the service response', response);
    return response.data?.createMeter;
};

export const update = async (id: string, record: Meter) => {

    console.debug('IN UPDATE', id, record);

    delete record.created;
    delete record.updated;

    const response = await client.graphql<GraphQLQuery<UpdateMeter>>({
                                                                         query: (updateMeter),
                                                                         variables: {input: record},
                                                                     });
    return response.data?.updateMeter;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteMeter>>({
                                                                         query: (deleteMeter),
                                                                         variables: {input: {id: id}},

                                                                     });
    return response.data?.deleteMeter;
};

// FNP-665: activate a meter (DRAFT->ACTIVE). Calls the narrow activateMeter mutation
// (no owner guard), NOT updateMeter — updateMeter silently no-ops for catalog meters.
export const activate = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<ActivateMeter>>({
                                                                          query: activateMeter,
                                                                          variables: {id},
                                                                      });
    return response.data?.activateMeter;
};
